import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import SearchIcon from "assets/icons/Icon";
import "components/common/customSearchField/customSearchField.scss";
import { useTranslation } from "react-i18next";
const SearchField = (props) => {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState("");
  const [boxShadow, setBoxShadow] = useState(false);
  const { name, handleChange, placeholder, value, margin, padding } = props;
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);
  window.addEventListener("click", function (e) {
    if (document.getElementById("clickbox")?.contains(e.target)) {
      // Clicked in box
    } else {
      // Clicked outside the box
      setBoxShadow(false);
    }
  });
  return (
    <div
      id="clickbox"
      className="search form-group has-search d-flex"
      style={{
        padding: padding || "0",
        margin: margin || "0.4rem",
        minWidth: "100%",
        ...(boxShadow && {
          boxShadow: "0 0 0 0.25rem rgb(13 110 253 / 25%)",
          transition: "boxShadow .15s ease-in-out,box-shadow .15s ease-in-out",
        }),
      }}>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder || t("ranch-name-or-location")}
        onChange={(e) => {
          e.preventDefault();
          setCurrentValue(e.target.value);
        }}
        onFocus={(e) => {
          e.preventDefault();
          setBoxShadow(true);
        }}
        onBlur={(e) => {
          e.preventDefault();
          setBoxShadow(false);
        }}
        value={currentValue}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            handleChange(name, currentValue);
            setBoxShadow(false);
          }
        }}
      />
      <SearchIcon
        width={15}
        cursor="pointer"
        onClick={() => {
          handleChange(name, currentValue);
          setBoxShadow(false);
        }}
      />
    </div>
  );
};

SearchField.propTypes = {
  props: PropTypes.any,
};

export default SearchField;
